import StreamService from '../../services/StreamService';
import AuthService from '../../services/AuthService';

// Action Types
export const STREAM_ACTIONS = {
  FETCH_STREAMS_REQUEST: 'FETCH_STREAMS_REQUEST',
  FETCH_STREAMS_SUCCESS: 'FETCH_STREAMS_SUCCESS',
  FETCH_STREAMS_FAILURE: 'FETCH_STREAMS_FAILURE',
  FETCH_STREAM_REQUEST: 'FETCH_STREAM_REQUEST',
  FETCH_STREAM_SUCCESS: 'FETCH_STREAM_SUCCESS',
  FETCH_STREAM_FAILURE: 'FETCH_STREAM_FAILURE',
  CREATE_STREAM_REQUEST: 'CREATE_STREAM_REQUEST',
  CREATE_STREAM_SUCCESS: 'CREATE_STREAM_SUCCESS',
  CREATE_STREAM_FAILURE: 'CREATE_STREAM_FAILURE',
  UPDATE_STREAM_REQUEST: 'UPDATE_STREAM_REQUEST',
  UPDATE_STREAM_SUCCESS: 'UPDATE_STREAM_SUCCESS',
  UPDATE_STREAM_FAILURE: 'UPDATE_STREAM_FAILURE',
  DELETE_STREAM_REQUEST: 'DELETE_STREAM_REQUEST',
  DELETE_STREAM_SUCCESS: 'DELETE_STREAM_SUCCESS',
  DELETE_STREAM_FAILURE: 'DELETE_STREAM_FAILURE',
  REGENERATE_KEY_REQUEST: 'REGENERATE_KEY_REQUEST',
  REGENERATE_KEY_SUCCESS: 'REGENERATE_KEY_SUCCESS',
  REGENERATE_KEY_FAILURE: 'REGENERATE_KEY_FAILURE',
  FETCH_STATS_REQUEST: 'FETCH_STATS_REQUEST',
  FETCH_STATS_SUCCESS: 'FETCH_STATS_SUCCESS',
  FETCH_STATS_FAILURE: 'FETCH_STATS_FAILURE',
  UPDATE_STREAM_STATUS: 'UPDATE_STREAM_STATUS',
  SET_SELECTED_STREAM: 'SET_SELECTED_STREAM',
  CLEAR_STREAM_ERROR: 'CLEAR_STREAM_ERROR'
};

export const fetchStreams = () => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.FETCH_STREAMS_REQUEST });
  try {
    const response = await StreamService.getAllStreams();
    dispatch({ type: STREAM_ACTIONS.FETCH_STREAMS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: STREAM_ACTIONS.FETCH_STREAMS_FAILURE, payload: error.message || 'Failed to fetch streams' });
  }
};

export const fetchStreamStats = () => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.FETCH_STATS_REQUEST });
  try {
    const response = await StreamService.getStreamStats();
    dispatch({ type: STREAM_ACTIONS.FETCH_STATS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: STREAM_ACTIONS.FETCH_STATS_FAILURE, payload: error.message || 'Failed to fetch statistics' });
  }
};

export const fetchStream = (id) => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.FETCH_STREAM_REQUEST });
  try {
    const response = await StreamService.getStream(id);
    dispatch({ type: STREAM_ACTIONS.FETCH_STREAM_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: STREAM_ACTIONS.FETCH_STREAM_FAILURE, payload: error.message || 'Failed to fetch stream' });
  }
};

export const createStream = (streamData, callback) => async (dispatch) => {
  const user = AuthService.getUser();
  const payload = {
    ...streamData,
    userId: user?.id
  };
  console.log('[StreamActions FIXED] createStream payload:', payload);
  dispatch({ type: STREAM_ACTIONS.CREATE_STREAM_REQUEST });
  try {
    const response = await StreamService.createStream(payload);
    dispatch({ type: STREAM_ACTIONS.CREATE_STREAM_SUCCESS, payload: response.data });
    dispatch(fetchStreams());
    dispatch(fetchStreamStats());
    if (callback) callback(null, response.data);
  } catch (error) {
    const responseData = error.response?.data || {};
    const errorMessage = responseData.details || responseData.error || error.message || 'Failed to create stream';
    dispatch({ type: STREAM_ACTIONS.CREATE_STREAM_FAILURE, payload: errorMessage });
    if (callback) callback({
      message: errorMessage,
      code: responseData.code || null,
      limit: responseData.limit || null,
      current: responseData.current || null,
      status: error.response?.status || null
    }, null);
  }
};

export const updateStream = (id, updates, callback) => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.UPDATE_STREAM_REQUEST });
  try {
    const response = await StreamService.updateStream(id, updates);
    dispatch({ type: STREAM_ACTIONS.UPDATE_STREAM_SUCCESS, payload: { id, updates } });
    dispatch(fetchStreams());
    if (callback) callback(null, response.data);
  } catch (error) {
    dispatch({ type: STREAM_ACTIONS.UPDATE_STREAM_FAILURE, payload: error.message || 'Failed to update stream' });
    if (callback) callback(error, null);
  }
};

export const deleteStream = (id, callback) => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.DELETE_STREAM_REQUEST });
  try {
    await StreamService.deleteStream(id);
    dispatch({ type: STREAM_ACTIONS.DELETE_STREAM_SUCCESS, payload: id });
    dispatch(fetchStreams());
    dispatch(fetchStreamStats());
    if (callback) callback(null);
  } catch (error) {
    dispatch({ type: STREAM_ACTIONS.DELETE_STREAM_FAILURE, payload: error.message || 'Failed to delete stream' });
    if (callback) callback(error);
  }
};

export const setSelectedStream = (stream) => ({
  type: STREAM_ACTIONS.SET_SELECTED_STREAM,
  payload: stream
});

export const updateStreamStatus = (streamKey, status, metadata) => ({
  type: STREAM_ACTIONS.UPDATE_STREAM_STATUS,
  payload: { streamKey, status, metadata }
});

export const clearStreamError = () => ({
  type: STREAM_ACTIONS.CLEAR_STREAM_ERROR
});

export const regenerateStreamKey = (id, callback) => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.REGENERATE_KEY_REQUEST });
  try {
    const response = await StreamService.regenerateKey(id);
    dispatch({ type: STREAM_ACTIONS.REGENERATE_KEY_SUCCESS, payload: { id, stream_key: response.data.stream_key } });
    dispatch(fetchStreams());
    if (callback) callback(null, response.data);
  } catch (error) {
    dispatch({ type: STREAM_ACTIONS.REGENERATE_KEY_FAILURE, payload: error.message || 'Failed to regenerate stream key' });
    if (callback) callback(error, null);
  }
};

